/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FanRemixContestSubmissionNotificationActionData } from './FanRemixContestSubmissionNotificationActionData';
import {
    FanRemixContestSubmissionNotificationActionDataFromJSON,
    FanRemixContestSubmissionNotificationActionDataFromJSONTyped,
    FanRemixContestSubmissionNotificationActionDataToJSON,
} from './FanRemixContestSubmissionNotificationActionData';

/**
 * 
 * @export
 * @interface FanRemixContestSubmissionNotificationAction
 */
export interface FanRemixContestSubmissionNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof FanRemixContestSubmissionNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof FanRemixContestSubmissionNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {FanRemixContestSubmissionNotificationActionData}
     * @memberof FanRemixContestSubmissionNotificationAction
     */
    data: FanRemixContestSubmissionNotificationActionData;
}

/**
 * Check if a given object implements the FanRemixContestSubmissionNotificationAction interface.
 */
export function instanceOfFanRemixContestSubmissionNotificationAction(value: object): value is FanRemixContestSubmissionNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function FanRemixContestSubmissionNotificationActionFromJSON(json: any): FanRemixContestSubmissionNotificationAction {
    return FanRemixContestSubmissionNotificationActionFromJSONTyped(json, false);
}

export function FanRemixContestSubmissionNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): FanRemixContestSubmissionNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': FanRemixContestSubmissionNotificationActionDataFromJSON(json['data']),
    };
}

export function FanRemixContestSubmissionNotificationActionToJSON(value?: FanRemixContestSubmissionNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': FanRemixContestSubmissionNotificationActionDataToJSON(value.data),
    };
}

